import { render, staticRenderFns } from "./overview-component.vue?vue&type=template&id=194721e1&scoped=true"
import script from "./overview-component.vue?vue&type=script&lang=ts"
export * from "./overview-component.vue?vue&type=script&lang=ts"
import style0 from "./overview-component.vue?vue&type=style&index=0&id=194721e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194721e1",
  null
  
)

export default component.exports